import { ellipsis, smartQuotes } from 'prosemirror-inputrules';
export const BaseInputRules = (builder) => {
    builder.addInputRules(() => ({ rules: [...smartQuotes, ellipsis] }));
};
